import React, { useRef, useCallback } from "react";
import Box from "apollo-react/components/Box";
import CommentToggle from "../CommentToggle/CommentToggle";
import SubFormCommentsSection from "../FormApproveComponents/SubFormComments/SubFormCommentsSection";
import { useComments } from "../../../hooks/useComments";

const AddCommentSection = ({
  formData,
  handleAddComment,
  requestProgressId,
  persona,
  requestId,
}) => {
  const subFormCommentsRef = useRef(null);

  // use the useComments hook to check if there are existing comments
  const { prevComments } = useComments({
    persona,
    requestId,
    initialFilters: { subFormId: formData.id },
    skipInitialFetch: false,
  });

  const handleAddCommentWithClose = useCallback(
    async (comment, subFormId, fileId, fileData) => {
      try {
        const result = await handleAddComment({
          comment,
          subFormId,
          requestsProgressId: requestProgressId,
          fileId,
          fileData,
        });

        // Refresh only this subform's comments
        if (subFormCommentsRef.current) {
          subFormCommentsRef.current.refreshComments();
        }

        return result;
      } catch (error) {
        console.error("Error adding comment:", error);
        throw error;
      }
    },
    [handleAddComment, requestProgressId]
  );

  return (
    <>
      <Box sx={{ marginTop: 3 }}>
        <SubFormCommentsSection
          ref={subFormCommentsRef}
          persona={persona}
          requestId={requestId}
          subFormId={formData.id}
          requestProgressId={requestProgressId}
        />
      </Box>
      <CommentToggle
        onAddComment={handleAddCommentWithClose}
        persona={persona}
        subFormId={formData.id}
        buttonText="Comment"
        hasComments={prevComments && prevComments.length > 0}
      />
    </>
  );
};

export default AddCommentSection;
